import { Tabs } from "antd";
import { TabProps } from "./type";

function AntTab(props: TabProps) {
  return <Tabs {...props} />;
}

export { AntTab as Tabs };
